import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=47d0e457&scoped=true&"
import script from "./Playlists.vue?vue&type=script&lang=ts&"
export * from "./Playlists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d0e457",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDataTable,VDialog,VForm,VOverlay})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d0e457')) {
      api.createRecord('47d0e457', component.options)
    } else {
      api.reload('47d0e457', component.options)
    }
    module.hot.accept("./Playlists.vue?vue&type=template&id=47d0e457&scoped=true&", function () {
      api.rerender('47d0e457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/digitalSignage/Playlists.vue"
export default component.exports